module.exports = __webpack_public_path__ + "static/caching_meme-e7f16d412cd929fafa1330a6e638fc6c.png";